/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { HubbleShipmentFiltersQuery } from "./HubbleShipmentFiltersQuery";
import {
  HubbleShipmentFiltersQueryFromJSON,
  HubbleShipmentFiltersQueryFromJSONTyped,
  HubbleShipmentFiltersQueryToJSON,
  HubbleShipmentFiltersQueryToJSONTyped,
} from "./HubbleShipmentFiltersQuery";

/**
 *
 * @export
 * @interface CustomerShipmentReportRequest
 */
export interface CustomerShipmentReportRequest {
  /**
   *
   * @type {HubbleShipmentFiltersQuery}
   * @memberof CustomerShipmentReportRequest
   */
  query: HubbleShipmentFiltersQuery;
  /**
   *
   * @type {boolean}
   * @memberof CustomerShipmentReportRequest
   */
  uploadToCompanyDocuments: boolean;
}

/**
 * Check if a given object implements the CustomerShipmentReportRequest interface.
 */
export function instanceOfCustomerShipmentReportRequest(
  value: object,
): value is CustomerShipmentReportRequest {
  if (!("query" in value) || value["query"] === undefined) return false;
  if (
    !("uploadToCompanyDocuments" in value) ||
    value["uploadToCompanyDocuments"] === undefined
  )
    return false;
  return true;
}

export function CustomerShipmentReportRequestFromJSON(
  json: any,
): CustomerShipmentReportRequest {
  return CustomerShipmentReportRequestFromJSONTyped(json, false);
}

export function CustomerShipmentReportRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomerShipmentReportRequest {
  if (json == null) {
    return json;
  }
  return {
    query: HubbleShipmentFiltersQueryFromJSON(json["query"]),
    uploadToCompanyDocuments: json["uploadToCompanyDocuments"],
  };
}

export function CustomerShipmentReportRequestToJSON(
  json: any,
): CustomerShipmentReportRequest {
  return CustomerShipmentReportRequestToJSONTyped(json, false);
}

export function CustomerShipmentReportRequestToJSONTyped(
  value?: CustomerShipmentReportRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    query: HubbleShipmentFiltersQueryToJSON(value["query"]),
    uploadToCompanyDocuments: value["uploadToCompanyDocuments"],
  };
}
